<template>
  <div class="nt-form__item">
    <button id="btn-submit" :class="['button button-full button--squared', getTheme]" @click.prevent="onSubmit">{{ text }}</button>
  </div>
</template>
 
<script>
export default {
  name: 'NtFormSubmit',
  props: {
    text: {
      type: String,
      default: 'Submit'
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    getTheme() {
      return `button--${this.theme}`
    }
  },
  methods: {
    onSubmit() {
      this.$parent.$emit('formSubmit')
    }
  },
}
</script>

<style lang="scss" scoped>
  .button {
    &--small {
      width: auto;
      font-size: 1rem
    }
  }
</style>